import { useQuery } from "@tanstack/react-query";

import TokenHelper from "@/utils/tokenHelper";
import { QUERY_KEYS } from "@api/queryKeys";

import {
  adaptRegulatoryClassification,
  adaptRegulatoryClassificationFilter,
} from "./adaptRegulatoryClassification.data";
import { regulatoryClassificationApi } from "./regulatoryClassification.service";

export const useRegulatoryClassificationQuery = () => {
  const isAuthenticated = !!TokenHelper.getAccessToken();

  return useQuery({
    queryKey: [QUERY_KEYS.regulatoryClassification],
    queryFn: () => regulatoryClassificationApi.getClassificationFilterData(),
    throwOnError: false,
    select: (data) => adaptRegulatoryClassification(data),
    refetchOnMount: true,
    staleTime: 5 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
    enabled: isAuthenticated,
  });
};

export const useRegulatoryClassificationFilterQuery = () => {
  const isAuthenticated = !!TokenHelper.getAccessToken();

  return useQuery({
    queryKey: [QUERY_KEYS.regulatoryClassification],
    queryFn: () => regulatoryClassificationApi.getClassificationFilterData(),
    throwOnError: false,
    select: (data) => adaptRegulatoryClassificationFilter(data),
    refetchOnMount: true,
    staleTime: 5 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
    enabled: isAuthenticated,
  });
};
